/* ==========================================================================
   GC Store Locator
   Reads store data from a JSON <script> block so Liquid owns the content and
   this file stays static. Google Maps is loaded with callback=gcLocatorInit.
   ========================================================================== */
(function () {
  'use strict';
  if (window.gcLocatorReady) return;
  window.gcLocatorReady = true;

  /* Cream map skin — mirrors the site palette (see assets/gc-custom.css). */
  var MAP_STYLE = [{"elementType":"geometry","stylers":[{"color":"#f5f3f0"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#6f6f6f"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"},{"weight":3}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#dcd9d4"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#4a4a4a"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e6e9e3"}]},{"featureType":"poi.park","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#eae7e2"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f0ece6"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e0dbd3"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e2e0dc"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9a9a9a"}]}];

  /* Default view: Midtown Manhattan. The section can override via data-* attrs. */
  var HOME = { lat: 40.7538, lng: -73.9799, zoom: 14 };
  var root, mapEl, map, stores = [], markers = [], infoWindow = null, activeIdx = -1;
  var input, suggestEl, statusEl, cards = [], suggestItems = [], suggestIdx = -1;

  function pin(fill, stroke) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="46" viewBox="0 0 34 46">' +
      '<path d="M17 45C17 45 33 27.6 33 17A16 16 0 1 0 1 17C1 27.6 17 45 17 45Z" ' +
      'fill="' + fill + '" stroke="' + stroke + '" stroke-width="2"/>' +
      '<circle cx="17" cy="16.5" r="5.6" fill="#FFF7F0"/></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }
  var ICON = { idle: pin('#C78038', '#FFF7F0'), active: pin('#13294B', '#FFF7F0') };

  function icon(which) {
    return {
      url: ICON[which],
      scaledSize: new google.maps.Size(34, 46),
      anchor: new google.maps.Point(17, 45)
    };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function directionsUrl(s) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(s.address + ', ' + s.city);
  }

  function infoHtml(s) {
    var hours = (s.hours || []).map(function (h) {
      return '<div><b>' + esc(h.days) + '</b> ' + esc(h.time) + '</div>';
    }).join('');
    return '' +
      '<div class="gc-iw">' +
        '<h3 class="gc-iw__name">' + esc(s.name) + '</h3>' +
        '<p class="gc-iw__addr">' + esc(s.address) + '<br>' + esc(s.city) + '</p>' +
        '<a class="gc-iw__tel" href="tel:' + esc(s.tel) + '">' + esc(s.phone) + '</a>' +
        '<div class="gc-iw__hours">' + hours + '</div>' +
        '<div class="gc-iw__actions">' +
          '<a class="gc-iw__btn gc-iw__btn--order" href="' + esc(s.order) + '" target="_blank" rel="noopener">Order</a>' +
          '<a class="gc-iw__btn gc-iw__btn--more" href="' + esc(s.url) + '">Details</a>' +
        '</div>' +
      '</div>';
  }

  /* ---------- focus / reset ---------- */

  function focusStore(idx, opts) {
    opts = opts || {};
    if (idx < 0 || idx >= markers.length) return;
    if (activeIdx > -1 && markers[activeIdx]) markers[activeIdx].setIcon(icon('idle'));
    activeIdx = idx;
    var m = markers[idx];
    m.setIcon(icon('active'));
    map.panTo(m.getPosition());
    if (typeof opts.zoom === 'number' && map.getZoom() < opts.zoom) map.setZoom(opts.zoom);
    infoWindow.setContent(infoHtml(stores[idx]));
    infoWindow.open({ map: map, anchor: m });
    if (opts.scroll !== false && mapEl.getBoundingClientRect().bottom < 120) {
      mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearActive() {
    if (activeIdx > -1 && markers[activeIdx]) markers[activeIdx].setIcon(icon('idle'));
    activeIdx = -1;
    if (infoWindow) infoWindow.close();
  }

  function fitAll() {
    var b = new google.maps.LatLngBounds();
    markers.forEach(function (m) { if (m.getMap()) b.extend(m.getPosition()); });
    if (!b.isEmpty()) map.fitBounds(b, { top: 60, right: 60, bottom: 60, left: 60 });
  }

  /* ---------- search ---------- */

  /* Fold the ways people actually type these names:
     "Hell's" -> hells, "6½" <-> "6 1/2", "(646) 861-0015" -> 6468610015. */
  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/½/g, ' 1/2 ')
      .replace(/[‘’'`]/g, '')
      .replace(/[^a-z0-9/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function haystack(s) {
    if (s._hay) return s._hay;
    s._hay = norm([s.name, s.address, s.city, s.borough, s.phone].join(' ')) +
      ' ' + String(s.phone).replace(/\D/g, '');
    return s._hay;
  }

  function matches(q) {
    var terms = norm(q).split(' ').filter(Boolean);
    if (!terms.length) return null;
    var out = [];
    stores.forEach(function (s, i) {
      var hay = haystack(s);
      if (terms.every(function (t) { return hay.indexOf(t) > -1; })) out.push(i);
    });
    return out;
  }

  function applyFilter(q) {
    var hits = matches(q);
    if (hits === null) { resetFilter(); return; }

    cards.forEach(function (c, i) { c.hidden = hits.indexOf(i) === -1; });
    markers.forEach(function (m, i) { m.setMap(hits.indexOf(i) === -1 ? null : map); });

    if (!hits.length) {
      // Never leave the page empty — fall back to the full set and say so.
      clearActive();
      markers.forEach(function (m) { m.setMap(map); });
      cards.forEach(function (c) { c.hidden = false; });
      statusEl.innerHTML = 'No stores match <b>' + esc(q) + '</b> — showing all ' + stores.length + '. ' +
        '<button type="button" class="gc-loc__reset">Clear</button>';
      goHome();
      return;
    }
    statusEl.innerHTML = 'Showing <b>' + hits.length + '</b> of ' + stores.length + ' stores. ' +
      '<button type="button" class="gc-loc__reset">Show all</button>';
    if (hits.length === 1) focusStore(hits[0], { zoom: 16, scroll: false });
    else { clearActive(); fitAll(); }
  }

  function resetFilter() {
    cards.forEach(function (c) { c.hidden = false; });
    markers.forEach(function (m) { m.setMap(map); });
    clearActive();
    statusEl.textContent = '';
    closeSuggest();
    goHome();
  }

  function goHome() {
    map.panTo({ lat: HOME.lat, lng: HOME.lng });
    map.setZoom(HOME.zoom);
  }

  function closeSuggest() {
    suggestEl.setAttribute('data-open', 'false');
    suggestEl.innerHTML = '';
    suggestItems = []; suggestIdx = -1;
    input.setAttribute('aria-expanded', 'false');
  }

  function openSuggest(q) {
    var hits = matches(q);
    if (hits === null || !hits.length) { closeSuggest(); return; }
    suggestEl.innerHTML = '';
    suggestItems = hits.slice(0, 8).map(function (i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.innerHTML = esc(stores[i].name) + '<span>' + esc(stores[i].address) + ', ' + esc(stores[i].city) + '</span>';
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        input.value = stores[i].name;
        closeSuggest();
        applyFilter(stores[i].name);
      });
      suggestEl.appendChild(li);
      return li;
    });
    suggestIdx = -1;
    suggestEl.setAttribute('data-open', 'true');
    input.setAttribute('aria-expanded', 'true');
  }

  function moveSuggest(delta) {
    if (!suggestItems.length) return;
    if (suggestIdx > -1) suggestItems[suggestIdx].setAttribute('aria-selected', 'false');
    suggestIdx = (suggestIdx + delta + suggestItems.length) % suggestItems.length;
    suggestItems[suggestIdx].setAttribute('aria-selected', 'true');
  }

  /* ---------- wire up ---------- */

  function buildMarkers() {
    infoWindow = new google.maps.InfoWindow({ maxWidth: 280 });
    google.maps.event.addListener(infoWindow, 'closeclick', clearActive);

    stores.forEach(function (s, i) {
      var m = new google.maps.Marker({
        position: { lat: s.lat, lng: s.lng },
        map: map,
        title: s.name,
        icon: icon('idle')
      });
      m.addListener('click', function () { focusStore(i, { zoom: 15, scroll: false }); });
      markers.push(m);
    });
  }

  function bindCards() {
    cards = Array.prototype.slice.call(root.querySelectorAll('.gc-loc__card'));
    cards.forEach(function (card) {
      var i = parseInt(card.getAttribute('data-index'), 10);
      var btn = card.querySelector('.gc-loc__btn--map');
      if (btn) btn.addEventListener('click', function () { focusStore(i, { zoom: 16 }); });
    });
  }

  function bindSearch() {
    var form = root.querySelector('.gc-loc__searchform');
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      t = setTimeout(function () {
        if (!q) { resetFilter(); return; }
        openSuggest(q);
      }, 140);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveSuggest(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveSuggest(-1); }
      else if (e.key === 'Escape') { closeSuggest(); }
      else if (e.key === 'Enter' && suggestIdx > -1) {
        e.preventDefault();
        var evt = new MouseEvent('mousedown');
        suggestItems[suggestIdx].dispatchEvent(evt);
      }
    });
    input.addEventListener('blur', function () { setTimeout(closeSuggest, 120); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      closeSuggest();
      var q = input.value.trim();
      if (!q) resetFilter(); else applyFilter(q);
    });
    statusEl.addEventListener('click', function (e) {
      if (!e.target.classList.contains('gc-loc__reset')) return;
      input.value = '';
      resetFilter();
    });
  }

  function deepLink() {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    for (var i = 0; i < stores.length; i++) {
      if (stores[i].slug === h) { focusStore(i, { zoom: 16 }); return; }
    }
  }

  window.gcLocatorInit = function () {
    root = document.querySelector('.gc-loc');
    if (!root) return;
    mapEl = root.querySelector('.gc-loc__map');
    var dataEl = root.querySelector('.gc-loc__data');
    if (!mapEl || !dataEl) return;

    try { stores = JSON.parse(dataEl.textContent); }
    catch (err) { return; }
    if (!stores.length) return;

    input = root.querySelector('.gc-loc__input');
    suggestEl = root.querySelector('.gc-loc__suggest');
    statusEl = root.querySelector('.gc-loc__status');

    var homeLat = parseFloat(mapEl.getAttribute('data-lat'));
    var homeLng = parseFloat(mapEl.getAttribute('data-lng'));
    var homeZoom = parseInt(mapEl.getAttribute('data-zoom'), 10);
    if (!isNaN(homeLat) && !isNaN(homeLng)) { HOME.lat = homeLat; HOME.lng = homeLng; }
    if (!isNaN(homeZoom)) { HOME.zoom = homeZoom; }

    map = new google.maps.Map(mapEl, {
      center: { lat: HOME.lat, lng: HOME.lng },
      zoom: HOME.zoom,
      styles: window.GC_MAPSTYLE || MAP_STYLE,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      gestureHandling: 'cooperative',
      clickableIcons: false
    });

    buildMarkers();
    bindCards();
    bindSearch();
    google.maps.event.addListenerOnce(map, 'idle', deepLink);
  };
})();
